<template>
  <div class="validation_schema_container">
    <v-skeleton-loader
      v-if="validationSchema.loading"
      class="skeleton"
      type="text"
    />
    <div v-else-if="validationSchema.items.length" class="validtion_schema">
      <div class="header_section" @click="expanded = !expanded">
        <div class="icon_left">
          <BaseIcon icon="$mdiCogs" />
        </div>
        <div class="header_title" v-text="$t('utils.validation_schemes')" />
        <v-btn class="icon_right" icon>
          <BaseIcon :icon="expanded ? '$mdiChevronUp' : '$mdiChevronDown'" />
        </v-btn>
      </div>
      <div v-if="expanded" class="body_section">
        <v-progress-linear
          v-if="isSubmiting"
          class="progression"
          indeterminate
        />
        <div
          v-for="(item, i) in formatedValidationSchema"
          :key="`vs${i}`"
          class="schema_item"
        >
          <input
            :checked="item.checked"
            type="checkbox"
            class="item_checkbox"
            :disabled="isSubmiting"
            @change="handleCheckedChange($event, item)"
          />
          <div class="check_label" v-text="item.name" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OrganizationAPI from "@/core/Services/organization.api";
import { ValidationSchema } from "@/core/Models/ValidationSchema";
export default {
  name: "CourseValidationSchema",
  props: {
    course: {
      type: Object,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
      isSubmiting: false,
      validationSchema: {
        loading: true,
        items: [],
      },
    };
  },
  computed: {
    formatedValidationSchema() {
      return this.validationSchema.items.map((item) => ({
        ...item,
        checked: item.courses.includes(this.course.id),
      }));
    },
  },
  created() {
    this.fetchValidationSchema();
  },
  methods: {
    async fetchValidationSchema() {
      this.validationSchema.loading = true;
      try {
        const res = await OrganizationAPI.getOrganizationValidationSchema(
          this.organizationId
        );
        this.validationSchema.items = res.data.results.map(
          (vs) => new ValidationSchema(vs)
        );
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.validationSchema.loading = false;
    },
    async handleCheckedChange(event, item) {
      this.isSubmiting = true;
      const validationSchema = this.validationSchema.items.find(
        (vs) => vs.id === item.id
      );
      try {
        if (event.target.checked) validationSchema.courses.push(this.course.id);
        else
          validationSchema.courses = validationSchema.courses.filter(
            (c) => c !== this.course.id
          );
        await OrganizationAPI.patchOrganizationValidationSchema({
          organizationId: this.organizationId,
          validationSchemaId: item.id,
          payload: {
            courses: validationSchema.courses,
          },
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.validation_schema_container {
  background: #fff;
  margin-bottom: 24px;
  user-select: none;
  .skeleton {
    height: 64px;
    width: 100%;
    ::v-deep {
      .v-skeleton-loader__bone {
        height: 64px;
      }
    }
  }
  .header_section {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    .icon_left {
      &::v-deep {
        svg {
          color: #707080;
        }
      }
    }
    .header_title {
      color: #353542;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      font-family: Inter;
    }
    .icon_right {
      margin-left: auto;
    }
  }
  .body_section {
    padding: 16px 48px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: calc(100% - 96px);
      height: 1px;
      background: #c4c4c4;
      top: 0;
      left: 48px;
    }
    .progression {
      position: absolute;
      width: calc(100% - 96px);
      height: 1px;
      top: 0;
      left: 48px;
      z-index: 2;
    }
    .schema_item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 0;
      .item_checkbox {
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
      .check_label {
        color: #333;
        font-family: Inter;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>
